import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Curriculum } from '../category'
import { LessonModule } from './lesson-module'

export const LessonModuleToCurriculum = pgTable(
  'lesson_module_to_curriculum',
  {
    lessonModuleId: uuid()
      .notNull()
      .references(() => LessonModule.id, { onDelete: 'cascade' }),
    curriculumId: uuid()
      .notNull()
      .references(() => Curriculum.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.lessonModuleId, table.curriculumId] }),
    index('lesson_module_to_curriculum_module_idx').on(table.lessonModuleId),
    index('lesson_module_to_curriculum_curriculum_idx').on(table.curriculumId),
  ],
)

export const lessonModuleToCurriculumRelations = relations(LessonModuleToCurriculum, ({ one }) => ({
  lessonModule: one(LessonModule, {
    fields: [LessonModuleToCurriculum.lessonModuleId],
    references: [LessonModule.id],
  }),
  curriculum: one(Curriculum, {
    fields: [LessonModuleToCurriculum.curriculumId],
    references: [Curriculum.id],
  }),
}))

export const InsertLessonModuleToCurriculumSchema = createInsertSchema(LessonModuleToCurriculum)
export const UpdateLessonModuleToCurriculumSchema = createUpdateSchema(LessonModuleToCurriculum).partial()
export const SelectLessonModuleToCurriculumSchema = createSelectSchema(LessonModuleToCurriculum)

export type InsertLessonModuleToCurriculum = typeof LessonModuleToCurriculum.$inferInsert
export type UpdateLessonModuleToCurriculum = z.infer<typeof UpdateLessonModuleToCurriculumSchema>
export type SelectLessonModuleToCurriculum = typeof LessonModuleToCurriculum.$inferSelect
